import { Modal } from "antd";
import { Formik } from "formik";
import Footer from "../../../layout/Footer";
import Header from "../../../layout/Header";
import { useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { addBotSchema } from "../../../utils/schema";
import HeroSection from "../../../layout/HeroSection";
import Loader from "../../../components/other/Loader";
import { useDispatch, useSelector } from "react-redux";
import { pageRoutes } from "../../../routes/pageRoutes";
import NoRecord from "../../../components/other/NoRecord";
import ErrorMessage from "../../../components/ErrorMessage";
import { fetchBotDirectory } from "../../../redux/action/moreAction";
import { pipGetTeamDirectory, pipViewDate } from "../../../utils/pip";
import {
  updateBot,
  fetchBotTypes,
  fetchWeightClassCategories,
} from "../../../redux/action/authAction";

const BotDirectory = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [filterByID,setFilterById] = useState("")
  const BotDetails = JSON.parse(localStorage.getItem("BotDetails"));
  const { user } = pipGetTeamDirectory();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { isLoading1, botList } = useSelector((state) => state.moreReducer);

  const { botTypes, weightClassCategories } = useSelector(
    (state) => state.authReducer
  );
  const [bot_type_id, setBot_type_id] = useState(
    BotDetails?.bot_type?.id ?? ""
  );
  const [weight_class_id, setWeight_class_id] = useState(
    BotDetails?.weight_class?.id ?? ""
  );
  const [design_type, setDesign_type] = useState(BotDetails?.design_type ?? "");

  const initialValues = {
    start_date: "",
    name: "",
    image: "",
  };

  const filteredBotList = botList?.filter((item)=>{
    return filterByID ? item?.weight_class?.id == filterByID : item
  })
  useEffect(() => {
    dispatch(fetchWeightClassCategories());
    dispatch(fetchBotTypes());
    dispatch(fetchBotDirectory());
  }, []);

  const handleUpdateBot = (values) => {
    const data = {
      ...values,
      bot_id: BotDetails?.id,
      created_by: user?.id,
      bot_type_id,
      design_type,
      weight_class_id,
    };

    const formdata = new FormData();
    Object.entries(data).forEach(([key, value]) => {
      if (key === "image") {
        if (value instanceof File) {
          formdata.append(key, value);
        }
      } else {
        formdata.append(key, value ?? "");
      }
    });

    const callback = (response) => {
      if (response.success) {
        setIsModalOpen(false);
        dispatch(fetchBotDirectory());
      }
    };
    dispatch(updateBot({ payload: formdata, callback }));
  };

  if (isLoading1) {
    return <Loader />;
  }

  return (
    <>
      <div>
        <Header />
        <HeroSection
          label={<h1 class="mb-3">{"Bot Directory"}</h1>}
          breadcrumbItems={[
            { name: "Home", path: `${pageRoutes?.home}/` },
            {
              name: "Bot Directory",
              path: `${pageRoutes?.home}/`,
            },
          ]}
        />
        <section className="my-5">
          <div className="container">
            <div className="row">
              <div className="col-md-12 d-flex align-items-center justify-content-end mb-4">
                <div className="form-group mb-3 d-flex align-items-center gap-2">
                  <label className="mb-0 d-block ct_fw_600" style={{whiteSpace:"nowrap"}}>
                    Filter By Weight class
                  </label>
                  <select
                    className="form-control"
                    onChange={(e) => {
                      setFilterById(e.target.value);
                    }}
                    value={filterByID}
                  >
                  
                    <option value="" >
                      All
                    </option>
                    {weightClassCategories?.map((item) => (
                      <option key={item.id} value={item?.id}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
            <div className="row">
              {filteredBotList?.length > 0 ? (
                filteredBotList?.map((item) => (
                  <div className="col-lg-4 mb-4">
                    <div className="ct_bot_directory_card_1">
                      <figure>
                        <div className="ct_bot_directory_img_1">
                          <img src={item?.image ?? ""} alt={item?.image} />
                        </div>
                        <figcaption>
                          <h4 className="ct_fw_400 ct_fs_24 mb-3">
                            {item?.name ?? "#N/A"}
                          </h4>
                          <div className="row">
                            <div className="col-sm-6 mb-3">
                              <p className="mb-0 ct_fw_600 text-dark">
                                Weight Class
                              </p>
                            </div>
                            <div className="col-sm-6 mb-3">
                              <p className="mb-0">
                                {item?.weight_class?.name ?? "#N/A"}
                              </p>
                            </div>
                            <div className="col-sm-6 mb-3">
                              <p className="mb-0 ct_fw_600 text-dark">
                                Belongs To (TEAM)
                              </p>
                            </div>
                            <div className="col-sm-6 mb-3">
                              <a
                                className="mb-0 ct_fs_20 et_active_underline"
                                href="javascript:void(0)"
                                onClick={() => {
                                  navigate(pageRoutes?.teamDetail, {
                                    state: {
                                      data: {
                                        user: item?.created_by,
                                      },
                                    },
                                  });
                                }}
                              >
                                {item?.created_by?.name ?? "#N/A"}
                              </a>
                            </div>
                            <div className="col-sm-6 mb-3">
                              <p className="mb-0 ct_fw_600 text-dark">
                                Bot Type
                              </p>
                            </div>
                            <div className="col-sm-6 mb-3">
                              <p className="mb-0">
                                {item?.bot_type?.name ?? "#N/A"}
                              </p>
                            </div>
                            <div className="col-sm-6 mb-3">
                              <p className="mb-0 ct_fw_600 text-dark">
                                Design Type
                              </p>
                            </div>
                            <div className="col-sm-6 mb-3">
                              <p className="mb-0">
                                {item?.design_type ?? "#N/A"}
                              </p>
                            </div>

                            <div className="col-sm-6 mb-3">
                              <p className="mb-0 ct_fw_600 text-dark">Date</p>
                            </div>
                            <div className="col-sm-6 mb-3">
                              <p className="mb-0">
                                {pipViewDate(item?.start_date) ?? "#N/A"}
                              </p>
                            </div>
                          </div>
                          {item?.created_by?.id == user?.id && (
                            <div className="text-center">
                              <button
                                type="button"
                                className="btn btn-secondary ct_btn_animate"
                                onClick={() => {
                                  setIsModalOpen(true);
                                  localStorage.setItem(
                                    "BotDetails",
                                    JSON.stringify(item)
                                  );
                                }}
                              >
                                {" "}
                                Edit Bot
                              </button>
                            </div>
                          )}
                        </figcaption>
                      </figure>
                    </div>
                  </div>
                ))
              ) : (
                <NoRecord className={"text-center ct_fs_20"} />
              )}
            </div>
          </div>
        </section>

        <Footer />
      </div>

      {/* Edit  bot modal S */}
      <>
        <Modal
          title={``}
          className="w-100"
          style={{ maxWidth: "800px" }}
          centered={true}
          open={isModalOpen}
          onCancel={() => {
            setIsModalOpen(false);
          }}
          footer={null}
        >
          <div className="mt-4">
            <div
              class="modal-dialog modal-dialog-centered mx-0"
              style={{ maxWidth: "100%" }}
            >
              <div class="modal-content border-0">
                <div class="modal-body py-0">
                  <h4 className="ct_fs_24 text-center mb-4">Edit Bot</h4>
                  <Formik
                    initialValues={{
                      start_date: BotDetails?.start_date ?? "",
                      name: BotDetails?.name ?? "",
                      image: BotDetails?.image ?? "",
                      description: BotDetails?.description ?? "",
                    }}
                    validationSchema={addBotSchema}
                    onSubmit={(values, actions) => {
                      handleUpdateBot(values);
                    }}
                  >
                    {({
                      values,
                      errors,
                      touched,
                      setTouched,
                      handleChange,
                      handleBlur,
                      setFieldValue,
                      handleSubmit,
                    }) => (
                      <form
                        onSubmit={handleSubmit}
                        className="ct_free_account_overflow px-3"
                        style={{ overflowX: "hidden" }}
                      >
                        {/* Image Input */}
                        <div className="form-group mb-3">
                          <label className="mb-2 d-block ct_fw_600">
                            Bot Image
                          </label>
                          <label for="ct_team_upload_img" className="d-block">
                            <input
                              type="file"
                              accept="image/*"
                              onChange={(event) => {
                                const file = event.currentTarget.files[0];
                                setTouched({ image: true });
                                setFieldValue("image", file);
                              }}
                              onBlur={handleBlur}
                              className="form-control d-none"
                              id="ct_team_upload_img"
                            />
                            <div className="ct_team_upload_box_23">
                              <p className="text-center mb-0 ct_fs_18">
                                Upload Image here
                              </p>

                              {values?.image && (
                                <img
                                  src={
                                    typeof values.image === "string"
                                      ? values.image
                                      : URL.createObjectURL(values.image)
                                  }
                                  className="ct_uploded_img"
                                  alt="Uploaded Preview"
                                />
                              )}
                            </div>
                          </label>
                          <ErrorMessage
                            errors={errors}
                            touched={touched}
                            fieldName="image"
                          />
                        </div>
                        {/* Bot Name */}
                        <div className="form-group mb-3">
                          <label className="mb-2 d-block ct_fw_600">
                            Bot Name <span className="ct_red_text">*</span>
                          </label>
                          <input
                            type="text"
                            placeholder="Enter bot name"
                            className="form-control"
                            value={values.name}
                            id="name"
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />

                          <ErrorMessage
                            errors={errors}
                            touched={touched}
                            fieldName="name"
                          />
                        </div>
                        <div className="row">
                          <div className="col-md-6">
                            <div className="form-group mb-3">
                              <label className="mb-2 d-block ct_fw_600">
                                Weight class
                              </label>
                              <select
                                className="form-control"
                                onChange={(e) => {
                                  setWeight_class_id(e.target.value);
                                }}
                                value={weight_class_id}
                              >
                                <option value="" disabled selected>
                                  Select Weight Class
                                </option>
                                {weightClassCategories?.map((item) => (
                                  <option key={item.id} value={item.id}>
                                    {item.name}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group mb-3">
                              <label className="mb-2 d-block ct_fw_600">
                                Bot Type
                              </label>
                              <select
                                className="form-control"
                                onChange={(e) => {
                                  setBot_type_id(e.target.value);
                                }}
                                value={bot_type_id}
                              >
                                <option value={""} selected disabled>
                                  Selected Bot Type
                                </option>
                                {botTypes?.map((bot) => (
                                  <option key={bot.id} value={bot.id}>
                                    {bot.name}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group mb-3">
                              <label className="mb-2 d-block ct_fw_600">
                                Design Type
                              </label>
                              <select
                                onChange={(e) => {
                                  setDesign_type(e.target.value);
                                }}
                                value={design_type}
                                className="form-control"
                              >
                                <option value={""} selected disabled>
                                  Selected Design Type
                                </option>
                                <option value={"Custom"}>Custom</option>
                                <option value={"Kit"}>Kit</option>
                              </select>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group mb-3">
                              <label className="mb-2 d-block ct_fw_600">
                                Date Started Competing
                              </label>
                              <input
                                type="date"
                                className="form-control"
                              
                                value={values.start_date}
                                id="start_date"
                                onChange={handleChange}
                                onBlur={handleBlur}
                              />

                              <ErrorMessage
                                errors={errors}
                                touched={touched}
                                fieldName="start_date"
                              />
                            </div>
                          </div>
                          {/* Description Input*/}
                          <div className="form-group mb-3">
                            <label className="mb-2 d-block ct_fw_600">
                              Description
                            </label>
                            <textarea
                              className="form-control"
                              rows={4}
                              placeholder="Enter Description"
                              value={values.description}
                              id="description"
                              onChange={handleChange}
                              onBlur={handleBlur}
                            />

                            <ErrorMessage
                              errors={errors}
                              touched={touched}
                              fieldName="description"
                            />
                          </div>
                        </div>

                        <div className="text-center mt-4">
                          <button
                            onClick={handleSubmit}
                            type="button"
                            className="btn btn-secondary ct_btn_animate px-5"
                          >
                            {" "}
                            Update
                          </button>
                        </div>
                      </form>
                    )}
                  </Formik>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </>
      {/* Edit  bot modal E */}
    </>
  );
};

export default BotDirectory;
